import { render, staticRenderFns } from "./CallingModal.vue?vue&type=template&id=e8aced76&"
import script from "./CallingModal.vue?vue&type=script&lang=js&"
export * from "./CallingModal.vue?vue&type=script&lang=js&"
import style0 from "./CallingModal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports